import $foreign from "./foreign.cjs";
var modifyImpl = $foreign.modifyImpl;
var $$new = $foreign.new;
var newWithSelf = $foreign.newWithSelf;
var read = $foreign.read;
var write = $foreign.write;
export { modifyImpl, $$new as new, newWithSelf, read, write };
